module.exports = __webpack_public_path__ + "img/info-gray-icon.cc1b008e.svg";